import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, belongsTo } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
let CustomFieldModel = (_dec = attr('string'), _dec2 = attr('number'), _dec3 = attr('boolean'), _dec4 = belongsTo('organization_custom_field', {
  inverse: null,
  async: false
}), _dec5 = attr('boolean', {
  defaultValue: false
}), _class = class CustomFieldModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "value", _descriptor, this);
    _initializerDefineProperty(this, "number_value", _descriptor2, this);
    _initializerDefineProperty(this, "boolean_value", _descriptor3, this);
    _initializerDefineProperty(this, "organization_custom_field", _descriptor4, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor5, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "value", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "number_value", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "boolean_value", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "organization_custom_field", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { CustomFieldModel as default };
//# sourceMappingURL=custom-field.js.map
